import { render, staticRenderFns } from "./QuestionnaireInitialPageTemplate.vue?vue&type=template&id=dce352f0&scoped=true"
import script from "./QuestionnaireInitialPageTemplate.vue?vue&type=script&lang=js"
export * from "./QuestionnaireInitialPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireInitialPageTemplate.vue?vue&type=style&index=0&id=dce352f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce352f0",
  null
  
)

export default component.exports